// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"3b4c5c95","883":"88cccd56"}[chunkId] + ".chunk.js";
};